import { WorkOrder } from './../../../models/work-order';
import { Validators } from '@angular/forms';

import { ActionField } from '../../../models/action-field';
import { ActionFormWithValidation } from './action-form-with-validation';
import { MeterService } from '../../../../inventory-management/meters/meters.service';
import { InactivateMeterConstants } from './../../../action-field/action-field-constants';
import { TokenCache } from './../../../../security/token-cache';
import { WorkorderActionJsonConstants } from './../../../action-field/workorder-action-json-constants';
import { InventoryIdExistsValidation } from '../form-field-validators/inventory-id-validators';
import { BlockService } from '../../../../inventory-management/blocks/blocks.service';
import { SpaceService } from '../../../../inventory-management/spaces/spaces.service';
import { NotPhysicallyRemovingMeter } from '../../../models/warning-constants';
import {debounceTime} from 'rxjs/operators';

export class InactivateMeterForm extends ActionFormWithValidation {
  constructor(actionIndex: string, private actionFields: ActionField[], _meterService: MeterService, _blockService: BlockService, _spaceService: SpaceService, tokenCache: TokenCache, workOrderActionJson: any, hasHistoricalDate: boolean, historicalDate: Date, overrideAsCity: boolean, workOrder: WorkOrder) {
    super(actionIndex, actionFields, tokenCache, _meterService, _blockService, _spaceService, hasHistoricalDate, overrideAsCity, workOrder, historicalDate);

    this.workOrderActionJsonObject = workOrderActionJson;
    this.onChanges();
  }

  private onChanges() {
    if (!this.workOrderActionJsonObject) {
      this.setValue(InactivateMeterConstants.RemoveEffectiveImmediately, true);
    }

    this.addControl(InactivateMeterConstants.SelectRemovalDate, [Validators.required]);

    if (this.controlExists(InactivateMeterConstants.RemoveEffectiveImmediately)) {
      this.subscribeToControl(InactivateMeterConstants.RemoveEffectiveImmediately).subscribe(value => {
        if (value) {
          this.disableControl(InactivateMeterConstants.SelectRemovalDate);
        }
        else {
          this.enableControl(InactivateMeterConstants.SelectRemovalDate);
          this.setAsRequired(InactivateMeterConstants.SelectRemovalDate);
          this.updateValueAndValidity(InactivateMeterConstants.SelectRemovalDate);
        }
      });
    }

    if (this.workOrderActionJsonObject) {
      if (this.workOrderActionJsonObject[InactivateMeterConstants.MeterIdText] !== this.workOrderActionJsonObject[InactivateMeterConstants.MeterSelect]
        && this.workOrderActionJsonObject[InactivateMeterConstants.MeterIdText] || this.workOrderActionJsonObject[InactivateMeterConstants.MeterSelect]) {
        this.setMeterSelectIdBasedOnGuid(this.isCityUser() ? InactivateMeterConstants.MeterIdText : InactivateMeterConstants.MeterSelect);
      }
      if (this.workOrderActionJsonObject[InactivateMeterConstants.RemoveEffectiveImmediately]) {
        this.disableControl(InactivateMeterConstants.SelectRemovalDate);
      }
    }

    if (this.isCityUser()) {
      this.setAsyncValidator(InactivateMeterConstants.MeterIdText, InventoryIdExistsValidation.MeterIdDoesNotExistValidator(this._meterService, null, null, this));
      this.subscribeToControl(InactivateMeterConstants.MeterIdText).pipe(debounceTime(1500)).subscribe(result => {
        this.setMeterGuidBasedOnDisplayId(result, WorkorderActionJsonConstants.meterGuid);
      });
      if (this.workOrderActionJsonObject) {
        if (!this.workOrderActionJsonObject[InactivateMeterConstants.MeterAddress]) {
          this._meterService.getMeterById(this.workOrderActionJsonObject[WorkorderActionJsonConstants.meterGuid]).subscribe(meter => {
            const meterAdress = `${meter.location.number} ${meter.location.streetDirection} ${meter.location.streetName}`;
            this.setValue(InactivateMeterConstants.MeterAddress, meterAdress);
          });
        }
      }

    }
    else {
      this.addControl(InactivateMeterConstants.MeterSelect, [Validators.required]);
      this.subscribeToControl(InactivateMeterConstants.MeterSelect).pipe(debounceTime(1500)).subscribe(result => {
        this.setMeterGuidBasedOnDisplayId(result, WorkorderActionJsonConstants.meterGuid);
      });

      this.setNotPhysicallyRemovingMeterWarnings();
    }

    if (!this.guidControlExists(WorkorderActionJsonConstants.blockGuid)) {
      this.addGuidControl(WorkorderActionJsonConstants.blockGuid);
    }

    if (!this.guidControlExists(WorkorderActionJsonConstants.meterGuid)) {
      this.addGuidControl(WorkorderActionJsonConstants.meterGuid);
    }
  }

  private setNotPhysicallyRemovingMeterWarnings(): void {
    if (!this.controlExists(InactivateMeterConstants.PhysicallyRemoveMeter)) {
      this.addControl(InactivateMeterConstants.PhysicallyRemoveMeter, []);
    }

    this.subscribeToControl(InactivateMeterConstants.PhysicallyRemoveMeter).pipe(debounceTime(1000)).subscribe(result => {
      //happens on initial creation of the checkbox, unsure why
      if(result === null
        || result === undefined
        || result === ''){ //result is sometimes null or undefined, default to true
        result = true; //but should always be set
        this.setValue(InactivateMeterConstants.PhysicallyRemoveMeter, result);
      }

      if (result === false && !(this.warnings.includes(NotPhysicallyRemovingMeter))) {
        this.pushToWarnings(NotPhysicallyRemovingMeter);
      }
      else if (this.warnings.includes(NotPhysicallyRemovingMeter) && result === true) {
        this.removeFromWarnings(NotPhysicallyRemovingMeter);
      }
      this.formGroup.updateValueAndValidity();
    });
  }

}
